import * as yup from 'yup';

interface ContactC2cSchemaProps {
  lastName: {
    format: string;
    required: string;
    minLength: string;
    maxLength: string;
  };
  firstName: {
    format: string;
    required: string;
    minLength: string;
    maxLength: string;
  };
  email: {
    format: string;
    required: string;
  };
}
const contactC2cSchema = (validationMsgs: ContactC2cSchemaProps) => {
  const { lastName, firstName, email } = validationMsgs;

  const onlyLettersRegEx = new RegExp(/^([^0-9]*)$/);
  return yup.object({
    lastName: yup
      .string()
      .trim()
      .matches(onlyLettersRegEx, lastName.format)
      .required(lastName.required)
      .min(2, lastName.minLength)
      .max(75, lastName.maxLength),
    firstName: yup
      .string()
      .trim()
      .matches(onlyLettersRegEx, firstName.format)
      .required(firstName.required)
      .min(2, firstName.minLength)
      .max(75, firstName.maxLength),
    email: yup.string().email(email.format).required(email.required),
  });
};
export default contactC2cSchema;
